import React from "react"
import "./CallAgenda.css"

const steps = [
  {
    id: "1",
    text: "Discuss how we can apply the proven IT staffing model in your market",
  },
  {
    id: "2",
    text: "What a potential startup plan could look like, and our path to profitability",
  },
  {
    id: "3",
    text: "What kind of leader you want to be, whether that’s as an owner-operator or as an investor",
  },
]

const CallAgenda = () => {
  return (
    <section className='call-agenda-section'>
      <div className='call-agenda-wrapper'>
        <div className='call-agenda-banner'>
          <h2>Here’s What We’ll Cover on the Call</h2>
        </div>
        <div className='call-agenda-body'>
          <p className='call-agenda-subtitle'>We’re going to..</p>
          <div className='call-agenda-line' aria-hidden='true'></div>
          <div className='call-agenda-steps'>
            {steps.map((step) => (
              <div className='call-agenda-step' key={step.id}>
                <div className='call-agenda-number'>{step.id}</div>
                <p>{step.text}</p>
              </div>
            ))}
            <div className='call-agenda-outcome'>
              <span>You’ll get Clarity</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CallAgenda








